export const albumActionTypes = {
	//Albums
	//Item
	ALBUM_REQUEST: 'ALBUM_REQUEST',
	ALBUM_RECEIVED: 'ALBUM_RECEIVED',
	ALBUM_REQUEST_FAILED: 'ALBUM_REQUEST_FAILED',
	//List
	ALBUM_LIST_REQUEST: 'ALBUM_LIST_REQUEST',
	ALBUM_LIST_WAIT: 'ALBUM_LIST_WAIT',
	ALBUM_LIST_RECEIVED: 'ALBUM_LIST_RECEIVED',
	ALBUM_SELECTION_LIST_RECEIVED: 'ALBUM_SELECTION_LIST_RECEIVED',
	ALBUM_LIST_FAILED: 'ALBUM_LIST_FAILED',
	ALBUM_LIST_CLEAR: 'ALBUM_LIST_CLEAR',
	//Selection
	ALBUM_SELECTED: 'ALBUM_SELECTED',
	ALBUM_DESELECTED: 'ALBUM_DESELECTED',
	CLEAR_ALBUM_SELECTION: 'CLEAR_ALBUM_SELECTION',
    ALBUM_TOGGLE_SELECTED: 'ALBUM_TOGGLE_SELECTED',
	SELECT_ALL_ALBUMS: 'SELECT_ALL_ALBUMS',
	//Creation
	ALBUM_CREATION_REQUEST: 'ALBUM_CREATION_REQUEST',
	ALBUM_CREATED: 'ALBUM_CREATED',
	ALBUM_CREATION_FAILED: 'ALBUM_CREATION_FAILED',
	//Update
	ALBUM_UPDATE_REQUEST: 'ALBUM_UPDATE_REQUEST',
	ALBUM_UPDATED: 'ALBUM_UPDATED',
	ALBUM_UPDATE_FAILED: 'ALBUM_UPDATE_FAILED',
	//Delete
	ALBUM_DELETE_REQUEST: 'ALBUM_DELETE_REQUEST',
	ALBUM_DELETED: 'ALBUM_DELETED',
	ALBUM_DELETE_FAILED: 'ALBUM_DELETE_FAILED',
	//Share
	ALBUM_FAVORIATE_REQUEST: 'ALBUM_FAVORITE_REQUEST',
	ALBUM_FAVORITED: 'ALBUM_FAVORITED',
	ALBUM_FAVORITE_FAILED: 'ALBUM_FAVORITE_FAILED',
	//Download
	ALBUM_DOWNLOAD_REQUEST: 'ALBUM_DOWNLOAD_REQUEST',
	ALBUM_DOWNLOAD_STARTED: 'ALBUM_DOWNLOAD_STARTED',
	ALBUM_DOWNLOAD_FAILED: 'ALBUM_DOWNLOAD_FAILED',
	//Add album to album
	ALBUM_ADD_TO_ALBUM_REQUEST: 'ALBUM_ADD_TO_ALBUM_REQUEST',
	ALBUM_ADD_TO_ALBUM_SUCCESS: 'ALBUM_ADD_TO_ALBUM_SUCCESS',
	ALBUMS_ADD_TO_ALBUM_SUCCESS: 'ALBUMS_ADD_TO_ALBUM_SUCCESS',
	ALBUM_ADD_TO_ALBUM_FAILED: 'ALBUM_ADD_TO_ALBUM_FAILED',
	//Add element to album
	ALBUM_ADD_ELEMENT_REQUEST: 'ALBUM_ADD_ELEMENT_REQUEST',
	ALBUM_ADD_ELEMENT_SUCCESS: 'ALBUM_ADD_ELEMENT_SUCCESS',
	ALBUM_ADD_ELEMENT_FAILURE: 'ALBUM_ADD_ELEMENT_FAILURE',
	//Add to disc
	ALBUM_ADD_TO_DISC_REQUEST: 'ALBUM_ADD_TO_DISC_REQUEST',
	ALBUM_ADD_TO_DISC_SUCCESS: 'ALBUM_ADD_TO_DISC_SUCCESS',
	ALBUM_ADD_TO_DISC_FAILED: 'ALBUM_ADD_TO_DISC_FAILED',
	//update album name in redux
  	UPDATE_ALBUM_NAME: 'UPDATE_ALBUM_NAME',
    ALBUM_SCROLL: 'ALBUM_SCROLL',
	ALBUM_SORT: "ALBUM_SORT",
    ALBUM_TOGGLE_RESORT : 'ALBUM_TOGGLE_RESORT',
    ALBUM_SAVE_ALBUM_SORT : 'ALBUM_SAVE_ALBUM_SORT',
    ALBUM_SAVE_ALBUM_SORT_SUCCESS : 'ALBUM_SAVE_ALBUM_SORT_SUCCESS',
    ALBUM_SAVE_ALBUM_SORT_FAILURE : 'ALBUM_SAVE_ALBUM_SORT_FAILURE',
    ALBUM_MOVE_ASSET_AFTER: 'ALBUM_MOVE_ASSET_AFTER',
    ALBUM_START_RESORT: 'ALBUM_START_RESORT',
    ALBUM_STOP_RESORT: 'ALBUM_STOP_RESORT',
    ALBUM_CANCEL_RESORT:'ALBUM_CANCEL_RESORT',
    ALBUM_DRAG_START: "ALBUM_DRAG_START",
	ALBUM_TOGGLE_ARRANGE_MODE: "ALBUM_TOGGLE_ARRANGE_MODE"

};


// WEBPACK FOOTER //
// ./src/album-view/actions/album-action-types.js